// extracted by mini-css-extract-plugin
export default {"kliksRow":"style_kliksRow__0n1mq","rowWithBorder":"style_rowWithBorder__F1yAh"};